import "../Dashboard.scss";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import PersonalAuthentication from "../components/common/PersonalAuthentication";
import ActiveUser from "../components/dashboard/ActiveUser";
import BannerNotice from "../components/dashboard/BannerNotice";
import MonthSales from "../components/dashboard/MonthSales";
import MonthTraffic from "../components/dashboard/MonthTraffic";
import PopularCategory from "../components/dashboard/PopularCategory";
import PopularProducts from "../components/dashboard/PopularProducts";
import TodaySales from "../components/dashboard/TodaySales";
import TodayTraffic from "../components/dashboard/TodayTraffic";
import UserAnalysis from "../components/dashboard/UserAnalysis";

const DashboardNew = () => {
	const user = useSelector((state) => state.auth.user);
	useEffect(() => {
		window.scrollTo({
			top: 0,
		});
	}, []);

	const [mediaResult, setMediaResult] = useState(null);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const media = function handleChange(e) {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	let normalUser = !user?.role || user?.role === "level_2";
	return (
		<div className="main-wrap">
			<div className={`max-width-apply`}>
				{mediaResult ? (
					// 모바일
					<div className={`dashboard-main-div`}>
						{/* 배너 문구 표기 */}
						<BannerNotice />
						{/* 금일 매출 */}
						<TodaySales />
						{/* 금일 유입량 / 활동 */}
						{!normalUser && <TodayTraffic />}
						{/* 이번 달 매출 */}
						<MonthSales />
						{/* 이번 달 유입량 / 참여율 */}
						{!normalUser && <MonthTraffic />}
						{/* 인기 클릭 상품 */}
						{!normalUser && <PopularProducts />}
						{/* 인기 게시물 */}
						{!normalUser && <PopularCategory />}
						{/* 가입자 활동*/}
						{!normalUser && <ActiveUser />}
						{/* 구독자 분석 */}
						{!normalUser && <UserAnalysis />}
					</div>
				) : (
					// PC
					<div className={`dashboard-main-div`}>
						{/* 배너 문구 표기 */}
						<BannerNotice />

						<div className={`dashboard-division`}>
							{/* 금일 매출 */}
							<TodaySales />
							{/* 금일 유입량 / 활동 */}
							{!normalUser && <TodayTraffic />}
						</div>

						{/* 이번 달 매출 */}
						<MonthSales />
						{!normalUser && (
							<div className={`dashboard-division`}>
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										gap: "1.5em",
										width: "52%",
									}}
								>
									{/* 이번 달 유입량 / 참여율 */}
									<MonthTraffic />
									{/* 인기 클릭 상품 */}
									<PopularProducts />
									{/* 인기 게시물 */}
									<PopularCategory />
									{/* 구독자 분석 */}
									<UserAnalysis />
								</div>
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										gap: "1.5em",
										width: "48%",
									}}
								>
									{/* 가입자 활동*/}
									<ActiveUser />
								</div>
							</div>
						)}
					</div>
				)}
			</div>
		</div>
	);
};
export default DashboardNew;
